import { useDispatch, useSelector } from "react-redux";
import SendEmailToVendor from "./SendEmailToVendor";
import { selectors as userProfileSelectors } from "redux/UserProfile";
import { removeEmailAttachment, setPoVendorEmail, uploadEmailAttachments } from "Store/AlertNotification/PoVendorEmail/PoVendorEmailAction";
import { useEffect, useState } from "react";
import { commononUploadClick, isEmail } from "utils";

const SendEmailToVendorContainer = (props?: any) => {
    const {
        itemDetails,
        setSendEmailAttachmentsList,
        sendEmailAttachmentsList,
        setSendEmailList,
        sendEmailList,
        setEmailAttachmentError,
        emailAttachmentError,
        setSendEmailerror,
        sendEmailError,
        isEmailSentAlert,
        dismissMailAlert,
        Popupcontent,
        hideDialog,
        popupOutlinebtnOnclick
    } = props;
    const dispatch = useDispatch();
    const [bccInputChange, setBccInputChange] = useState<any>('')
    const [toInputChange, setToInputchange] = useState<any>('')
    let isChangeable = true

    const {
        poVendorEmailDetails,
        userDetails,
        emailAttachmentList,
        isPoVendorEmailSent
    }: any = useSelector((state: any) => ({
        poVendorEmailDetails: state.PoVendorEmailReducers.poVendorEmailDetails,
        userDetails: userProfileSelectors.getUserDetails(state),
        emailAttachmentList: state.PoVendorEmailReducers.attachments,
        isPoVendorEmailSent: state.PoVendorEmailReducers.isPoVendorEmailSent
    }));

    useEffect(() => {
        setBccInputChange('')
        setToInputchange('')
        isChangeable = true
    }, [])

    useEffect(() => {
        setSendEmailAttachmentsList(emailAttachmentList?.list);
        dispatch(setPoVendorEmail({ ...poVendorEmailDetails, emailAttachments: emailAttachmentList?.list }));
    }, [emailAttachmentList]);

    useEffect(() => {
        if (poVendorEmailDetails?.emailAttachments?.length > 0 && poVendorEmailDetails?.fleetRequestDetailId === itemDetails?.fleetRequestDetailId) {
            setSendEmailList(poVendorEmailDetails?.emailAttachments)
            setSendEmailAttachmentsList(poVendorEmailDetails?.emailAttachments ?? [])
        }
    }, [poVendorEmailDetails])

    const onEmailAddressFieldChange = (e: any, item?: any, name?: any) => {
        const emailRegex = isEmail(item);
        let nameTemp = name == "toEmailAddress" ? "toEmailError" : "bccEmailError";
        if (item === undefined || item === "" || item === null || emailRegex) {
            isChangeable = false
            setSendEmailerror({ ...sendEmailError, [nameTemp]: "Please enter a valid email address" });
            return
        } else {
            setSendEmailerror({ ...sendEmailError, [nameTemp]: "" });
            dispatch(setPoVendorEmail({ ...poVendorEmailDetails, [name]: e }));
            if (name == 'toEmailAddress') {
                setToInputchange('')
            } else {
                setBccInputChange('')
            }
            isChangeable = true
        }
    }

    const onFieldChange = (e: any) => {
        if (e?.target?.value?.trim()?.length > 0) {
            setSendEmailerror({ ...sendEmailError, bodyEmailError: "" });
        }
        dispatch(setPoVendorEmail({ ...poVendorEmailDetails, [e?.target?.name]: e?.target?.value }));
    }

    const isUploaded = (name: string) =>
        sendEmailAttachmentsList?.find((x: any) => (x.name || (x as any).fileName) === name);

    // To upload attachments
    const onUploadClick = (fileList: Array<File>) => {
        let listItem = {
            fileList: fileList,
            uploadedList: sendEmailAttachmentsList,
          }
        commononUploadClick(listItem, setEmailAttachmentError, isUploaded, dispatch, uploadEmailAttachments, null, false);
    };

    const onRemoveClick = (index: number) => {
        const newArr = sendEmailAttachmentsList.slice();
        newArr.splice(index, 1);
        const newFileList = [...sendEmailList];
        newFileList.splice(index, 1);
        setSendEmailList(newFileList);
        dispatch(removeEmailAttachment(newArr));
        setEmailAttachmentError("");
    }

    const onBccInputChange = (value?: any) => {
        if (isChangeable) {
            if (value == '') {
                setSendEmailerror({ ...sendEmailError, bccEmailError: "" });
            }
            setBccInputChange(value)
            isChangeable = true
        }
    };

    const onToInputChange = (value?: any) => {
        if (isChangeable) {
            if (value == '') {
                setSendEmailerror({ ...sendEmailError, toEmailError: "" });
            }
            setToInputchange(value)
            isChangeable = true
        }
    };

    return (
        <SendEmailToVendor
            poVendorEmailDetails={poVendorEmailDetails}
            userDetails={userDetails}
            onFieldChange={onFieldChange}
            onEmailAddressFieldChange={onEmailAddressFieldChange}
            itemDetails={itemDetails}
            attachmentsList={sendEmailAttachmentsList}
            list={sendEmailList}
            attachmentError={emailAttachmentError}
            setList={setSendEmailList}
            setAttachmentError={setEmailAttachmentError}
            onUploadClick={onUploadClick}
            onRemoveClick={onRemoveClick}
            sendEmailError={sendEmailError}
            isEmailSentAlert={isEmailSentAlert}
            dismissMailAlert={dismissMailAlert}
            isPoVendorEmailSent={isPoVendorEmailSent}
            onBccInputChange={onBccInputChange}
            bccInputChange={bccInputChange}
            onToInputChange={onToInputChange}
            toInputChange={toInputChange}
            Popupcontent={Popupcontent}
            hideDialog={hideDialog}
            popupOutlinebtnOnclick={popupOutlinebtnOnclick} />
    );
}

export default SendEmailToVendorContainer
